import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/es";
import fileDownload from "js-file-download";

import {
  IonAccordion,
  IonAccordionGroup,
  IonActionSheet,
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import { cloudDownload, cloudDownloadOutline, eye, eyeOutline } from "ionicons/icons";

import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import StyledButton from "../../components/basicsComponents/StyledButton/StyledButton";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import useTituloPagina from "../../hooks/tituloPagina";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function EstudiosPaciente() {
  const [usuario, setUsuario] = useState({});
  const [cargando, setCargando] = useState(false);
  const [tituloPagina, setTituloPagina] = useState("");
  const [urlAxioPP, setUrlAxio] = useState("");
  const [listadoEstudios, setListadoEstudios] = useState([]);
  const [listadoEstudiosFiltrados, setListadoEstudiosFiltrados] = useState([]);
  const [estudioSel, setEstudioSel] = useState(-1);
  const [listadoEstudiosFiltro, setListadoEstudiosFiltro] = useState([]);
  const [estudioPdf, setEstudioPdf] = useState({
    fecha: "",
    nombre: "",
    doc: {},
  });
  const [abrirModal, setAbrirModal] = useState(false);
  const [abrirDesplegableTipoEstudio, setAbrirDesplegableTipoEstudio] = useState(false);

  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };
  const history = useHistory();
  useTituloPagina();

  const abrirCerrarModal = () => setAbrirModal(!abrirModal);

  const traerEstudiosPaciente = async (paciente) => {
    let estudios = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(
        `${url}EstudiosImagenes/TraerNombresArchivos/${paciente.documentoNro}`,
        config
      );
      if (response.data.length !== 0) {
        estudios = response.data;
      } else {
        estudios = [];
      }

      estudios = estudios.map((estudio, i) => {
        let nombre = estudio.nombre;
        nombre = nombre.replace(`${paciente.documentoNro}_`, "");
        nombre = nombre.replace(".pdf", "");
        nombre = nombre.replace(".pdf", "");
        let fecha = dayjs(
          new Date(
            Number(nombre.substr(-8, 4)),
            Number(nombre.substr(-4, 2)) - 1,
            Number(nombre.substr(-2, 2))
          )
        );
        if (fecha.isValid() && (fecha.isBefore(dayjs()) || dayjs().isSame(fecha))) {
          return {
            ...estudio,
            codigo: i,
            fecha: fecha.format("DD/MM/YYYY"),
            text: nombre.substr(
              0,
              nombre.substr(-11, 3) === " - " ? nombre.length - 11 : nombre.length - 8
            ),
          };
        } else {
          return {
            ...estudio,
            codigo: i,
            fecha: "No disponible",
            text: nombre,
          };
        }
      });
      setListadoEstudios(estudios);
      setListadoEstudiosFiltrados(estudios);
      setListadoEstudiosFiltro(estudios);
    } catch ({ response }) {
      mostrarNotificacion(true, "Error: " + response.data, "rojo");
    }
  };

  const FiltrarEstudios = (value) => {
    setCargando(true);
    if (value !== -1) {
      let listado = [];

      listadoEstudios.map((estudio) => {
        if (parseInt(value) === estudio.estudioCod) {
          listado.push(estudio);
        }
      });
      setEstudioSel(value);
      setListadoEstudiosFiltrados(listado);
    } else {
      setEstudioSel(value);
      setListadoEstudiosFiltrados(listadoEstudios);
    }
    setCargando(false);
  };

  const BuscarEstudio = async (estudio, pdfDoc, pdfUrl) => {
    try {
      const response = await axios.request({
        url: `${urlAxioPP}EstudiosImagenes/DescargarGaImagenesPdf/${usuario.documentoNro}?nombreArchivo=${estudio.nombre}`,
        method: "GET",
        responseType: "blob",
        auth: `Bearer ${usuario.token}`,
      });

      if (response.data.size > 0) {
        const pdfBlob = new Blob([response.data]);
        if (pdfDoc && !pdfUrl) {
          fileDownload(pdfBlob, `${estudio.text}.pdf`);
        } else {
          if (!pdfDoc && pdfUrl) {
            setEstudioPdf({
              fecha: estudio.fecha,
              nombre: estudio.text,
              doc: pdfBlob,
            });
            abrirCerrarModal();
          }
        }
      }
    } catch (error) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar buscar el estudio seleccionado",
        "rojo"
      );
    }

    return null;
  };

  const BuscarPedido = async (estudio, pdfDoc, pdfUrl) => {
    try {
      const url = localStorage.getItem("urlAxioPP");
      const config = {
        headers: { Authorization: `Bearer ${usuario.token}`, responseType: "blob" },
      };

      let response;
      switch (estudio.estudioNom) {
        case "PAP":
          response = await axios.request({
            url: `${url}EstudiosImagenes/DescargarPAPPdf/${usuario.documentoNro}?fecha=${dayjs(
              estudio.fecha
            ).format("DDMMYYYY")}`,
            method: "GET",
            responseType: "blob",
            auth: `Bearer ${usuario.token}`,
          });
          break;
        case "VideoColposcopia":
          response = await axios.request({
            url: `${url}EstudiosImagenes/DescargarVideocolposcopiaPdf/${
              usuario.documentoNro
            }?fecha=${dayjs(estudio.fecha).format("DDMMYYYY")}`,
            method: "GET",
            responseType: "blob",
            auth: `Bearer ${usuario.token}`,
          });
          break;
        case "Colposcopia":
          response = await axios.request({
            url: `${url}EstudiosImagenes/DescargarColposcopiaPdf/${
              usuario.documentoNro
            }?fecha=${dayjs(estudio.fecha).format("DDMMYYYY")}`,
            method: "GET",
            responseType: "blob",
            auth: `Bearer ${usuario.token}`,
          });
          break;
        default:
          mostrarNotificacion(true, "Estudio no disponible", "rojo");
      }
      if (response.data.size > 0) {
        const pdfBlob = new Blob([response.data]);
        if (pdfDoc && !pdfUrl) {
          fileDownload(
            pdfBlob,
            `${estudio.estudioNom}-${dayjs(estudio.fecha).format("DD/MM/YYYY")}.pdf`
          );
        } else {
          if (!pdfDoc && pdfUrl) {
            setEstudioPdf({
              fecha: estudio.fecha,
              nombre: estudio.estudioNom,
              doc: pdfBlob,
            });
            abrirCerrarModal();
          }
        }
      }
    } catch (error) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar buscar el estudio seleccionado",
        "rojo"
      );
    }

    return null;
  };

  const DescargarPdf = (estudio) => {
    setCargando(true);
    if (estudio) {
      BuscarEstudio(estudio, true, false);
    } else {
      mostrarNotificacion(true, "Estudio sin archivo guardado", "rojo");
    }
    setCargando(false);
  };

  const VisualizarPdf = (estudio) => {
    setCargando(true);
    if (estudio) {
      BuscarEstudio(estudio, false, true);
    } else {
      mostrarNotificacion(true, "Estudio sin archivo guardado", "rojo");
    }
    setCargando(false);
  };

  useEffect(() => {
    setCargando(true);
    try {
      const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
      if (sesion) {
        traerEstudiosPaciente(sesion);
        setUsuario(sesion);
        setUrlAxio(localStorage.getItem("urlAxioPP"));
        setTituloPagina(localStorage.getItem("nombreClinica"));
        document.title = localStorage.getItem("tituloWeb");
      }
    } catch (e) {
      history.push({ pathname: "/ErrorPage" });
    }
    setCargando(false);
  }, []);

  //cosas para el modal
  const [numPages, setNumPages] = React.useState(null);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <>
      {listadoEstudios.length <= 0 ? (
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol>
              <div className="ion-text-center">
                <p>No tiene estudios registrados aun</p>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      ) : (
        <>
          {/* Tabla */}
          <IonList lines="none">
            <IonGrid className="tabla">
              <IonItem className="fila cabecera amarillo-sol">
                <IonCol className="celda cabecera">
                  <p>Fecha estudio</p>
                </IonCol>
                <IonCol className="celda cabecera">
                  <p>Nombre de estudio</p>
                </IonCol>
                <IonCol className="celda cabecera">
                  <p>Estudio</p>
                </IonCol>
              </IonItem>
              {listadoEstudiosFiltrados.map((fila, i) => (
                <IonItem key={i} className="fila amarillo-sol  ion-justify-content-start">
                  <IonCol className="celda">
                    <IonLabel>{fila.fecha}</IonLabel>
                  </IonCol>
                  <IonCol className="celda">
                    <IonLabel>{fila.text}</IonLabel>
                  </IonCol>
                  <IonCol className="celda" itemProp="">
                    <div className="iconColumn">
                      <IonButton shape="roud" fill="clear" onClick={() => VisualizarPdf(fila)}>
                        <IonIcon size="large" ios={eyeOutline} md={eye} />
                      </IonButton>
                      <IonButton shape="roud" fill="clear" onClick={() => DescargarPdf(fila)}>
                        <IonIcon size="large" ios={cloudDownloadOutline} md={cloudDownload} />
                      </IonButton>
                    </div>
                  </IonCol>
                </IonItem>
              ))}
            </IonGrid>
          </IonList>

          <IonActionSheet
            header={`${estudioPdf.nombre}-${dayjs(estudioPdf.fecha).format("DD/MM/YYYY")}`}
            buttons={[
              {
                text: "Cancelar",
                role: "cancel",
                data: {
                  action: "cancel",
                },
              },
            ]}
            onDidDismiss={abrirCerrarModal}
          >
            <IonContent className="ion-padding">
              {estudioPdf.doc && (
                <Document file={estudioPdf.doc} onLoadSuccess={onDocumentLoadSuccess}>
                  {[...Array(numPages)].map((_, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={1}
                      renderTextLayer={false}
                      wrap={false}
                    />
                  ))}
                </Document>
              )}
            </IonContent>
          </IonActionSheet>
          <IonModal isOpen={abrirModal} backdropDismiss={false} expand="block">
            <IonHeader>
              <IonToolbar>
                <IonTitle>{`${estudioPdf.nombre} - ${estudioPdf.fecha}`}</IonTitle>
                {/* <IonButtons slot="end"> */}
                <StyledButton
                  slot="end"
                  strong={true}
                  onClick={() => abrirCerrarModal()}
                  fill="clear"
                  className="amarillo-sol-text"
                >
                  Cerrar
                </StyledButton>
                {/* </IonButtons> */}
              </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
              {estudioPdf.doc && (
                <Document file={estudioPdf.doc} onLoadSuccess={onDocumentLoadSuccess}>
                  {[...Array(numPages)].map((_, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={1}
                      renderTextLayer={false}
                      wrap={false}
                    />
                  ))}
                </Document>
              )}
            </IonContent>
          </IonModal>
          <CustomToast
            openToast={toast.open}
            onDidDismiss={(e) => mostrarNotificacion(false, "", "")}
            message={toast.mensaje}
            colorNotificacion={toast.tipo}
          />
        </>
      )}
      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </>
  );
}
